import React from 'react';

const MAP = {
  active:  { label: 'Активен', cls: 'sb--active' },
  archive: { label: 'Архив',   cls: 'sb--archived' },
};

export default function StatusBadge({ status }) {
  const m = MAP[status] || { label: status, cls: '' };
  return <span className={'sb ' + m.cls}>{m.label}</span>;
}
